'use client';

import { useEffect, useState } from 'react';
import { BackDrop } from '@wishket/design-system';

import { useArticleFirstLine } from './ArticleDetailTutorial.hooks';
import { HighlightStep, ScrapStep } from './ArticleDetailTutorial.parts';

import { useLocalStorageState, useAuth } from '@/shared/hooks';
import { STORAGE_KEY } from '@/shared/constants';
import { ClientOnly } from '@/shared/Components';

interface ArticleDetailTutorialProps {
  content: string;
}

enum TutorialStep {
  Ready = 'ready',
  Highlight = 'highlight',
  Scrap = 'scrap',
}

const ArticleDetailTutorial = ({ content }: ArticleDetailTutorialProps) => {
  const { isAuth } = useAuth();
  const firstLineData = useArticleFirstLine(content);
  const [tutorialCompleted, setTutorialCompleted] = useLocalStorageState(
    STORAGE_KEY.TUTORIAL,
    false
  );
  const [step, setStep] = useState<TutorialStep>(
    tutorialCompleted ? TutorialStep.Ready : TutorialStep.Highlight
  );

  const isVisibleTutorial = step !== TutorialStep.Ready && firstLineData;

  // TODO: 컨텐츠 상세 튜토리얼 preventScroll 속성, yogokit,designSystem 수정후 true로 변경하고, 해당 effect 제거
  useEffect(() => {
    if (isVisibleTutorial) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isVisibleTutorial]);

  const handleHighlightNext = () => {
    setStep(TutorialStep.Scrap);
  };

  const handleFinishTutorial = () => {
    setTutorialCompleted(true);
    window.scrollTo({ top: 0 });
    setStep(TutorialStep.Ready);
  };

  return (
    <ClientOnly>
      {isVisibleTutorial && (
        <>
          <BackDrop isBlack preventScroll={false} />
          {step === TutorialStep.Highlight && (
            <HighlightStep
              isLoggedIn={isAuth}
              firstLineData={firstLineData}
              onNext={handleHighlightNext}
            />
          )}
          {step === TutorialStep.Scrap && (
            <ScrapStep onNext={handleFinishTutorial} isLoggedIn={isAuth} />
          )}
        </>
      )}
    </ClientOnly>
  );
};

export default ArticleDetailTutorial;
